import React from 'react';
import { resolveTestId } from '@cvent/nucleus-test-automation';
import Textbox from 'nucleus-form/src/components/inputs/Textbox';
import { some, zipObject, map } from 'lodash';
import { resolve, select } from '@cvent/nucleus-dynamic-css';
import { includesCaseInsenstive } from '../../utils/searchUtils';
import { defaultMemoize } from 'reselect';

const standardKeywordFilterFields = defaultMemoize((displayOptions) => {
  const fields = ['firstName', 'lastName', 'company', 'category', 'title', 'biography', 'designation', 'prefix'];
  return zipObject(fields, map(fields, field => {
    return {
      isVisible: () => displayOptions[field],
      matchesKeyword: (speaker, keyword) => includesCaseInsenstive(speaker[field], keyword)
    };
  }));
});

function matchesKeywordFilter(speaker, displayOptions, keyword) {
  if (!keyword) {
    return false;
  }
  const standardFields = standardKeywordFilterFields(displayOptions);
  return some(standardFields, field => {
    return field.isVisible() && field.matchesKeyword(speaker, keyword);
  });
}

/**
 * Filter speakers based on keyword filter
 */
export function filterSpeakers(speakers, displayOptions, keywordFilterValue) {
  const hasKeywordFilter = !!keywordFilterValue;
  return speakers.filter(speaker => {
    const matchOnKeywordFilter = matchesKeywordFilter(speaker, displayOptions, keywordFilterValue);
    return (!hasKeywordFilter) || (hasKeywordFilter && matchOnKeywordFilter);
  });
}

/**
 * Component for allowing guest-side user to filter speakers
 */
export default function SpeakerFilters({
  updateKeywordFilter, keywordFilterValue, translate, ...rest
}) {
  return (<div {...resolve(rest, 'filterContainer')}>
    <Textbox
      key="keyword-filter"
      {...select(rest, 'keywordFilter')}
      {...resolveTestId(rest, '-search')}
      fieldName="keywordFilter"
      label={translate('SpeakersWidget_NameSearchBox_SearchSpeakers__resx')}
      hideLabel
      placeholder={translate('SpeakersWidget_NameSearchBox_SearchSpeakers__resx')}
      value={keywordFilterValue}
      onChange={(fieldName, value) => updateKeywordFilter(value)}
      maxLength={30}
    />
  </div>);
}
